import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@/shared/assets/close-icon.svg?react';

type Props = {
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
};

const GlobalSearchInput = forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, onClose }, ref) => {
    const { t } = useTranslation();

    return (
      <div className="flex items-center gap-[0.8rem] pl-[1rem]">
        <input
          ref={ref}
          type="text"
          value={value}
          onChange={event => onChange(event.target.value)}
          placeholder={t('personalAccount.globalSearch.placeholder')}
          className="grow min-w-0 bg-transparent p3 text-primary placeholder:text-white/24 outline-none"
        />

        <button
          type="button"
          aria-label={t('common.close')}
          onClick={onClose}
          className="flex items-center justify-center size-[3.2rem] shrink-0 rounded-full bg-white/10 text-primary cursor-pointer hover:bg-white/16 transition-colors">
          <CloseIcon className="size-[1.6rem]" />
        </button>
      </div>
    );
  }
);

GlobalSearchInput.displayName = 'GlobalSearchInput';

export { GlobalSearchInput };
